import { format } from "date-fns";

/**
 * Check if we're running in production (not localhost)
 * This is used to determine if we should use relative URLs for API requests
 * to leverage Vercel's proxy rewrites. Works with any custom domain configured in Vercel.
 * @returns boolean indicating if we're in production
 */
export function isProduction(): boolean {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  
  // If we're on localhost or 127.0.0.1, we're in development
  if (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.endsWith('.localhost')
  ) {
    return false;
  }
  
  // Otherwise, we're in production (works with any custom domain: atportal.co.uk, recycle.rocks, etc.)
  return true;
}

export function formatDate(dateString: string) {
  if (!dateString) return;
  var date = new Date(dateString.substring(0, 10)).toISOString().slice(0, -1);

  return format(new Date(date), "MMMM dd, yyyy"); // ex: April 27, 2022;
}

export function numberWithCommas(x: number | string) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function formatNumberToCurrency(number: number) {
  return number.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
}
